import { type ReduxUser } from 'models';
import { useScreenSizeObserver } from 'common/hooks';
import variables from 'common/styles/variables.json';

import { type BadgeOptions, NavigationMenu } from './NavigationMenu';
import { UserAvatar } from './UserAvatar';

type P = {
  badges?: BadgeOptions;
  viewer: ReduxUser;
};

// TODO fix CSS
const Navigation = ({ badges, viewer }: P) => {
  const { screenWidth } = useScreenSizeObserver();
  const isCollapsed = screenWidth < variables.screenXl.value;

  return (
    <>
      <UserAvatar viewer={viewer} isCollapsed={isCollapsed} />
      <NavigationMenu isCollapsed={isCollapsed} badges={badges} />
    </>
  );
};

export default Navigation;
